import type { AudioJobStatus } from '../types/db';

const STATUS_CONFIG: Record<
  AudioJobStatus,
  { label: string; classes: string }
> = {
  pending: { label: 'In attesa', classes: 'bg-slate-100 text-slate-700' },
  fetching: { label: 'Recupero articoli', classes: 'bg-amber-100 text-amber-700' },
  scripting: { label: 'Scrittura script', classes: 'bg-amber-100 text-amber-700' },
  script_ready: {
    label: 'Script pronto',
    classes: 'bg-sky-100 text-sky-700',
  },
  awaiting_text_approval: {
    label: 'Attesa approvazione testo',
    classes: 'bg-yellow-100 text-yellow-700',
  },
  text_approved: {
    label: 'Testo approvato',
    classes: 'bg-sky-100 text-sky-700',
  },
  generating_voice: {
    label: 'Generazione voce',
    classes: 'bg-amber-100 text-amber-700',
  },
  voice_ready: {
    label: 'Voce pronta',
    classes: 'bg-sky-100 text-sky-700',
  },
  mixing: { label: 'Mix audio', classes: 'bg-amber-100 text-amber-700' },
  awaiting_audio_approval: {
    label: 'Attesa approvazione audio',
    classes: 'bg-yellow-100 text-yellow-700',
  },
  audio_approved: {
    label: 'Audio approvato',
    classes: 'bg-sky-100 text-sky-700',
  },
  distributed: {
    label: 'Distribuito',
    classes: 'bg-emerald-100 text-emerald-700',
  },
  ready: { label: 'Pronto', classes: 'bg-emerald-100 text-emerald-700' },
  failed: { label: 'Errore', classes: 'bg-rose-100 text-rose-700' },
};

export default function StatusBadge({ status }: { status: AudioJobStatus }) {
  const cfg = STATUS_CONFIG[status];
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${cfg.classes}`}
    >
      {cfg.label}
    </span>
  );
}
